export enum Site {
  Globetrotters = 'globetrotters',
  TheNextGlobetrotter = 'thenextglobetrotter',
}

export const currentSite = process.env.NEXT_PUBLIC_SITE as Site
